import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { ErrorText, FindLoad } from 'utils';
import { AddModalButton, CustomNumericFormat, ToastScreen } from 'components';
import { CollectRow } from './collectRow';
import { collectionActions } from 'store';
import { COLLECT_RESERVE_ACTION_TYPE } from '../constants';

export const CollectReserve = ({ carrier }) => {
  const [error, setError] = useState('');
  const [amount, setAmount] = useState(null);
  const loader = FindLoad(COLLECT_RESERVE_ACTION_TYPE)
  const dispatch = useDispatch()

  const changeAmount = (e) => {
    const value = e?.floatValue;
    if (value <= carrier?.outstandingDebt && value <= carrier?.reserve?.keptAmount) {
      setAmount(value);
      error === 'amount' && setError('');
    }
  }

  const handlePay = () => {
     if (amount){
       dispatch(collectionActions.collectReserve(carrier?.id, { amount: amount }))
     }else{
       setError('amount');
     }
  }

  return (
    <div className='collect-reserve-loads-modal'>
      <p className='collect-modal-title'>Collect Reserve</p>
      <div className='flex-column' style={{ gap: 16 }}>
        <CollectRow title='Company:' value={carrier?.companyName} />
        <CollectRow title='Total Debt:' value={carrier?.outstandingDebt} type={'price'} />
        <CollectRow title='Available Active Reserve Amount:' value={carrier?.reserve?.keptAmount || 0} type={'price'} />
        <CustomNumericFormat
          errorName={error}
          error={error === 'amount' && ErrorText.field}
          label={'Amount*'}
          placeholder={'Enter Amount'}
          name={'amount'}
          value={amount}
          handleChangeMiles={changeAmount}
          isAllowed={(values) => {
            const { floatValue } = values;
            const isValid =
              floatValue === undefined ||
              (floatValue <= carrier?.outstandingDebt && floatValue <= carrier?.reserve?.keptAmount);

            if (!isValid && floatValue !== undefined) {
              toast.dismiss();
              toast(
                <ToastScreen
                  type={'error'}
                  text={'Entered amount must be less than or equal to the available amount.'}
                />
              );
            }
            return isValid;
          }}
        />
        <AddModalButton
          loading={!!loader?.length}
          handleClick={handlePay}
          text={'Collect'}
        />
      </div>
    </div>
  );
}
